import { BRANDS_SLUG } from "../core/urls";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import IndentedParagraphMedium from "./IndentedParagraphMedium";
import MediumLink from "./MediumLink";
import React from "react";
import HeadingSmall from "./HeadingSmall";
import Grid from "./Grid";
import BrandLink from "./BrandLink";
import { RESKINNED_PROMO_ITEM } from "../core/constants";

function ForBrands({ brands, heading, text }) {
  const brandsHref = `/${BRANDS_SLUG}`;
  const brandsList = [RESKINNED_PROMO_ITEM, ...brands];

  return (
    <Box bg="yellow" pt={[50, null, 90, null]} pb={[90, null, 130, null]}>
      <BoxWithGutter>
        <Box mb={70}>
          <HeadingSmall uppercase>Brands we work with –</HeadingSmall>
        </Box>

        <Grid desktopCols={4} mobCols={2}>
          {brandsList.map((brand) => {
            return <BrandLink key={brand.slug} brand={brand} />;
          })}
        </Grid>

        <Box
          maxWidth={[null, "80vw", null, null]}
          mx="auto"
          mt={[40, null, 100, null]}
        >
          <IndentedParagraphMedium>{text}</IndentedParagraphMedium>
        </Box>
        <Box mt={[40, null, 60, null]}>
          <MediumLink text="Reskinned for brands" href={brandsHref} />
        </Box>
      </BoxWithGutter>
    </Box>
  );
}

export default ForBrands;
